import { render, staticRenderFns } from "./addManageDialog.vue?vue&type=template&id=72645f36"
import script from "./addManageDialog.vue?vue&type=script&lang=js"
export * from "./addManageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports